/** 数据分析 */
<template>
  <div class="wrap-home">
    <side-nav :nav-list="navList">
      <div class="logo-box color-white f-df f-ai pd-left10">
        <figure class="mg-right10 icon-logo">
          <img src="@/assets/images/logo.png" width="100%" height="100%">
        </figure>
        <figcaption>内容管理与分析系统</figcaption>
      </div>
    </side-nav>
  </div>
</template>
<script>
import sideNav from '@/components/side-nav.vue' // 评分量表
import pageConfig from './page.config.js'
export default {
  name: 'DataAnalysis',
  // 注册组件
  components: {
    sideNav
  },
  data() {
    return {
      navList: []
    }
  },
  mounted() {
    const userMenuAuth = this.$store.state.userInfo.menuAuth || [] // 获取当前用户所有模块权限
    // const userMenuAuth = [
    //   {
    //     code: '04-01'
    //   }
    // ]
    this.navList = JSON.parse(JSON.stringify(pageConfig.navList)).reduce((preArr, item) => {
      if (item.authId) {
        const isLimit = userMenuAuth.find(menuAuth => menuAuth.code === item.authId)
        if (isLimit) preArr.push(item)
      } else {
        item.children = item.children.filter(elem => {
          return userMenuAuth.find(menuAuth => menuAuth.code === elem.authId)
        })
        if (item.children && item.children.length) preArr.push(item)
      }
      return preArr
    }, [])
  },
  methods: {}
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/color.less';
.icon-logo{
  width: 25px;
  height: 28px;
}
.logo-box{
  height: 47px;
  line-height: 47px;
  background-color: #1F31A2;
}
</style>
